<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
    <div class="top">
        <a routerLink="/home/vacations/drivers/exercise/{{ driverProfile?.active_assignment?.exercise?.id }}/operational/{{ driverProfile?.active_assignment?.operativa?.id }}">
            <h3>Chóferes / {{ driverProfile?.active_assignment?.exercise?.name }} / {{ driverProfile?.active_assignment?.operativa?.name }}</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>{{ driverProfile?.employee?.first_name }} {{ driverProfile?.employee?.last_name }}</h2>
            </div>
            <!-- TODO: Hacer de esto un componente -->
            <div class="subtitle background">
                <mat-icon>check_circle</mat-icon>
                Período de vacaciones <strong>{{ driverProfile?.current_period?.name }}</strong> {{ driverProfile?.current_period?.type }} ({{ driverProfile?.current_period?.start_date }} -
                {{ driverProfile?.current_period?.end_date }})
            </div>
        </a>
        <div class="boton">
            <app-vacation-switch></app-vacation-switch>
            <button class="b1" mat-button>Editar</button>
        </div>
    </div>

    <div class="info">
        <div class="profile-picture">
            @if (driverProfile?.employee?.avatar_url) {
            <img [src]="driverProfile?.employee?.avatar_url" alt="Profile Picture">
            } @else {
            <img src="assets/images/profile-stock.png" alt="Profile Picture">
            }
        </div>

        <div class="header-cards">

            <!-- TODO: Hacer componente de card -->
            <div class="card">
                <div class="title">EMPRESA</div>
                <div class="numbers">
                    <span>{{ driverProfile?.employee?.company }}</span>
                </div>
            </div>

            <div class="card">
                <div class="title">ANTIGÜEDAD</div>
                <div class="numbers">
                    <span>{{ driverProfile?.employee?.years_worked }} años</span>
                </div>
            </div>

            <div class="card">
                <div class="title">ALTA</div>
                <div class="numbers">
                    <mat-icon id="check">check_circle</mat-icon>
                    <span>{{ driverProfile?.employee?.join_date }}</span>
                </div>
            </div>

            <div class="card">
                <div class="title">DÍAS USADOS</div>
                <div class="numbers">
                    <span>{{ driverProfile?.vacation_status?.total_days_used }} de {{ driverProfile?.vacation_status?.total_days_entitled }} días</span>
                </div>
            </div>

            <div class="card">
                <div class="title">DÍAS PENDIENTES</div>
                <div class="numbers">
                    @if ((driverProfile?.vacation_status?.days_pending_approval || 0) > 0) {
                    <mat-icon id="error">error</mat-icon>
                    }
                    <span>{{ driverProfile?.vacation_status?.days_pending_approval }} días</span>
                </div>
            </div>

            <div class="card">
                <div class="title">DÍAS PERSONALES</div>
                <div class="numbers">
                    <span>{{ driverProfile?.vacation_status?.days_personal_available }} de {{ (driverProfile?.vacation_status?.days_personal_available || 0) + (driverProfile?.vacation_status?.days_personal_used || 0) }} disponibles</span>
                </div>
            </div>

            <div class="card">
                <div class="title">OPERATIVA</div>
                <div class="numbers">
                    <span>{{ driverProfile?.active_assignment?.operativa?.name }}</span>
                </div>
            </div>

            <div class="card">
                <div class="title">PROTOCOLO</div>
                <div class="numbers">
                    <span>{{ driverProfile?.active_assignment?.protocol?.name }}</span>
                </div>
            </div>
        </div>
    </div>


</div>

<div class="content">

    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">

        <mat-tab label="PETICIONES PENDIENTES">
            <div class="petitions">
                @for (petition of petitions; track petition.id) {
                <app-driver-petition [petitions]="petition"></app-driver-petition>
                }
            </div>
        </mat-tab>

        <mat-tab label="CALENDARIO">
            <div class="left">
                <app-calendar></app-calendar>
            </div>
            <div class="right">
                <h4>Información</h4>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit, similique.</p>
                <mat-divider></mat-divider>
                <div class="line">
                    <div class="available"></div>
                    <p>Días disponibles para reservar.</p>
                </div>
                <mat-divider></mat-divider>
                <div class="line">
                    <div class="selected"></div>
                    <p>Día seleccionado.</p>
                </div>
                <mat-divider></mat-divider>
                <div class="line">
                    <div class="event"></div>
                    <p>Día de vaciones</p>
                </div>
                <mat-divider></mat-divider>
                <div class="line">
                    <div class="blocked"></div>
                    <p>Día bloqueado, no puede hacer reservas.</p>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="PETICIONES ANTERIORES">

        </mat-tab>

    </mat-tab-group>

</div>